import React, { useState, useEffect } from "react";
import Search from "../Search";

import { Button, Input, Modal, SessionExpired } from "../../common";
import { ReactComponent as LogoSVG } from "../../../assets/images/colorFull_logo.svg";
import { ReactComponent as LogoWhite } from "../../../assets/logoXL.svg";
import { ReactComponent as SearchIcon } from "../../../assets/icons/searchIcon.svg";
import { ReactComponent as DemoMan } from "../../../assets/icons/demoMan.svg";
import { ReactComponent as InSearch } from '../../../assets/promptIcons/inSearch.svg';
import { ReactComponent as InSearch40 } from '../../../assets/promptIcons/inSearch40.svg';
import { ReactComponent as InCategory } from '../../../assets/promptIcons/inCategory.svg';
import { ReactComponent as InCustom } from '../../../assets/promptIcons/inCustom.svg';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  HEADER_CREATE_BUTTON,
  HEADER_LOGIN_BUTTON,
} from "../../../constants/constants";
import UserProfileDropdown from "../UserProfileHeader";
import { setSearch, setCountryData, setSearchResults } from "../../../store/search/searchSlice";

import {
  HOME_BANNER_TEXT_2,
} from "../../../constants/constants";

import { setUserInfo, clearUserInfo } from "../../../store/auth/authSlice";
import { useGetUserQuery } from "../../../store/auth/usersApiSlice";
import { setClearClaimDetails } from "../../../store/claim/claimSlice";
import DemoModal from "../../common/DemoModal";
import { handlePromptStripePayment, scrollToTop } from "../../../utils/Helper";
import PercentageBanner from "../GptPrompts/PercentageBanner";
import Footer from "../Footer";
const Banner = ({ prompt }) => {
  const bannerData = [{
    id: 1,
    icon: InSearch,
    headerText: 'Search for Prompts',
    text: (<>Use keywords like <span className="font-semibold">“follow-up” “escalation”</span> or <span className="font-semibold">“dispute resolution”</span> to find what you need quickly.</>),
  },
  {
    id: 2,
    icon: InCategory,
    headerText: 'Pick a Category',
    text: 'Explore curated categories to match your collection stage or tone.',
  },
  {
    id: 3,
    icon: InCustom,
    headerText: 'Copy & Customize',
    text: 'Copy the prompt, tailor it to your needs, and use it in your preferred AI tool—like ChatGPT, Gemini, or Claude',
  }]

  const categoriesData = [{
    id: 1,
    headerText1: 'Payment Reminders and Overdue Communication',
    headerText2: 'Payment Tracking and Internal Reporting',
    text1: "Send friendly reminders for upcoming payments and handle overdue notices to keep customers informed and ensure timely payments.",
    text2: "Track payments and create easy-to-understand reports to stay on top of financial updates and decisions."
  },
  {
    id: 2,
    headerText1: 'Customer Behavior Analysis and Prioritization',
    headerText2: 'Dispute Resolution and Customer Support',
    text1: "Understand how customers pay and focus efforts on those most likely to need follow-ups.",
    text2: "Solve customer issues quickly and clearly to keep them happy while managing payments effectively."
  },
  {
    id: 3,
    headerText1: 'Training and Resource Development',
    headerText2: 'Automation and Templates for Efficiency',
    text1: "Provide tools and training to help teams improve their skills and work efficiently",
    text2: "Use ready-made templates and automated tools to save time and make work smoother."
  },
  {
    id: 4,
    headerText1: 'Dispute Management and Escalations',
    headerText2: 'Cross-Functional Collaboration and Strategy',
    text1: "Resolve payment issues fairly and escalate when needed to keep everything on track.",
    text2: "Work with other teams to create plans and ensure everyone is aligned for better results"
  },
  {
    id: 5,
    headerText1: 'Negotiation and Payment Arrangements',
    headerText2: 'Strategy Improvement and Communication Materials',
    text1: "Work with customers to set up payment plans that work for both sides.",
    text2: "Update strategies and create clear, simple materials to improve communication and outcomes."
  },
  ]
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { REACT_APP_GPT_PROMPT_PAYMENT_LINK } = process.env;
  const { token, userInfo } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const [isSessionExpired, setSessionExpired] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false)
  const { data, refetch, isSuccess, isError, error } = useGetUserQuery(token, {
    skip: !token,
  });
  useEffect(() => {
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }
    if (isSuccess) {
      dispatch(setUserInfo({ ...data }));
    }
  }, [data, dispatch, isSuccess]);

  useEffect(() => {
    if (data) {
      refetch();
    }
  }, [refetch, data]);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };
  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    // const res = await fetch(`${process.env.REACT_APP_K_HUB_URL}/api/auth/logout`, {
    //   method: "POST",
    //   credentials: "include", // 👈 VERY important
    // });

    // const data = await res.json();
    dispatch(setClearClaimDetails())
    dispatch(clearUserInfo());
    navigate(`/login/${prompt ? "gpt-prompts/access" : "home"}`);
  };

  const setHandleSearch = (value) => {
    dispatch(setSearchResults([]))
    dispatch(setSearch(value));
    navigate('/gpt-prompts/search');
  }
  return (

    <div className="banner_section h-screen sm:h-full md:h-[70vh] mb-[-5vh]">
      <DemoModal
        showDemoModal={showDemoModal}
        setShowDemoModal={setShowDemoModal}
      />
      <header>
        <nav className="border-gray-200 px-4 lg:px-6 py-4  shadow-lg ">
          <div className="flex flex-wrap justify-between items-center mx-auto max-w-7xl ">
            <Link to={prompt ? "/gpt-prompts/access" : "/"} className="flex items-center">
              <LogoSVG />
            </Link>
            <div className="flex items-center lg:order-2">
              {/* {!prompt && <button
                className="sm:block hidden"
                onClick={() => {
                  navigate("/search");
                }}
              >
                <SearchIcon />
              </button>} */}
              {isSessionExpired && <Modal modalHandle={sessionExpiredPopup}>
                <SessionExpired handleNavigate={sessionExpiredPopup} />
              </Modal>}
              {!userInfo && (
                <>
                  <Link
                    to={`/login/${prompt ? "prompt" : "home"}`}
                    className={`${prompt ? "text-[#3C4848]" : "text-white"} font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2  focus:outline-none hidden md:block`}
                  >
                    Login
                  </Link>
                  {/* {!prompt && <Button onClick={() => setShowDemoModal(true)} classes={"text-white bg-primary font-medium rounded-full text-sm px-6 lg:px-6 py-2 lg:py-2.5 mr-2 hidden md:block rounded text-sm font-semibold shadow-[0_-2px_0_#bc3214] hover:shadow-none"}>Schedule Demo</Button>} */}
                  <button onClick={() => setShowDemoModal(true)} className="text-white bg-primary hover:bg-primary-400 font-semibold rounded text-sm px-6 py-2.5 mr-2 hidden md:block shadow-[0_-2px_0_#bc3214] transform transition-all duration-300 hover:shadow-[0_0_0_#0000] hover:-translate-y-[2px]">
                    Schedule Demo
                  </button>
                </>
              )}
              {
                (!userInfo?.has_gpt && prompt) && <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes="hidden sm:block w-[131px] h-[48px] bg-white text-[#002940] rounded-[8px] font-semibold flex justify-center items-center border border-[#002940]">Get Started</Button>

              }
              {userInfo && <UserProfileDropdown />}
              <button
                onClick={toggleDrawer}
                data-collapse-toggle="navbar-default"
                type="button"
                className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 "
                aria-controls="navbar-default"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M4 9H16"
                    stroke="#6E6E6E"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                  <path
                    d="M4 16H28"
                    stroke="#6E6E6E"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                  <path
                    d="M16 23L28 23"
                    stroke="#6E6E6E"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div
            id="drawer-example"
            className={`fixed top-0 left-0 z-40 h-screen max-h-screen p-4 overflow-y-auto transition-transform ${isOpen ? "transform-none" : "-translate-x-full"
              } bg-white w-80 `}
            tabIndex="-1"
            aria-labelledby="drawer-label"
          >
            <button
              type="button"
              onClick={toggleDrawer}
              data-drawer-hide="drawer-example"
              aria-controls="drawer-example"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center "
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">Close menu</span>
            </button>
            <div className="flex flex-col pt-5 text-left">
              {userInfo ? <Link
                to="#"
                onClick={handleLogout}
                className="text-primary hover:bg-gray-50 focus:ring-4 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none "
              >
                Log out
              </Link> : <Link
                to={`/login/${prompt ? "prompt" : "home"}`}
                className={`hover:bg-gray-50 focus:ring-4 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none text-primary`}
              >
                Log In
              </Link>}
              {userInfo && <Link
                to="/dashboard"
                className="text-primary hover:bg-gray-50 focus:ring-4 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none "
              >
                Dashboard
              </Link>}
              {!prompt ? <Link
                to="/sign-up"
                className={`text-white bg-primary hover:bg-primary-800 font-medium rounded-full text-sm px-6 lg:px-6 py-2 lg:py-2.5 mr-2 focus:outline-none`}
              >
                {prompt ? "Get Started" : HEADER_CREATE_BUTTON}
              </Link> :
                <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes="w-[131px] h-[48px] bg-white text-[#002940] rounded-[8px] font-semibold flex justify-center items-center border border-[#002940]">Get Started</Button>}
            </div>
          </div>
        </nav>
      </header>
      <div className={`max-w-[1280px] mx-auto flex justify-center align-item items-center heightBannerAdjustment ${!prompt && "md:h-full"} px-2`}>
        <div className="w-full md:my-auto">
          <div className="tag_gradient-border"><div className="hero_tag"><div>Trusted by Global Brands</div></div></div>
          {/* <div className="w-[254px] rounded-full text-[#E6ECF0] header-border m-auto">Trusted by 1100+ Businesses</div> */}
          <h1 style={{ fontSize: "50px", color: "#012234" }} className="leading-tight w-full mx-auto font-bold text-white text-f32 font-sans lg:text-f62 line-1 md:text-f32">
            {prompt ? <p className="text-[#012234]">Unleash GPT's Full Potential with <span className="text-[#FF9700]">Ready-Made Prompts</span></p> : <p className="text-[48px] md:text-[80px] font-semibold text-[#FFFFFF]">Explore. <span>Engage.</span> Expand.</p>}
          </h1>
          <p className={`leading-normal mt-6 mx-auto text-white md:text-para3 text-para2 font-[500] text-[1rem] ${prompt ? "max-w-4xl" : "max-w-2xl"}`}>
            {prompt ? <p className={`text-[#012234]`}>Streamline your workflow with expertly curated ChatGPT templates tailored for every industry, task, and need—from emails to follow-ups to reminders. Save time, spark ideas, and get results faster.</p> : HOME_BANNER_TEXT_2}
          </p>
          {/* {prompt && <p className="text-[22px] font-bold text-[#012234] mt-2">Write a professional follow-up email to a potential client... |</p>} */}
          <div className="my-10">
            <Search prompt={prompt} />
          </div>
        </div>
      </div>
      {prompt && <>
        <div className='flex flex-col items-center gap-3 my-10'>
          <div className='bg-secondary text-link rounded px-6 py-2 text-center'>
            {"Perfect Prompt in Seconds".toUpperCase()}
          </div>
          <h1 className='text-f40 font-bold text-primary'>Getting Started in 3 Easy Steps</h1>
          <p className='w-full px-3 sm:px-0 md:w-[716px] text-secondarytwo font-f18'>Find, customize, and deploy the ideal prompts effortlessly. Just follow these three simple steps to supercharge your workflow.</p>
        </div>
        <PercentageBanner bannerData={bannerData} removeCover={true} center={true} />
        <div className='px-3 sm:px-0 max-w-[1280px] m-auto my-10 py-4'>
          <div className='w-[143px] bg-secondary text-link rounded py-2 px-6 text-center'>
            {"Categories".toUpperCase()}
          </div>
          <div className='flex flex-col sm:flex-row sm:justify-between items-center'>
            <div className='max-w-[668px] text-left flex flex-col gap-2 py-2'>
              <h1 className='text-f40 font-bold text-primary'>Explore by Categories</h1>
              <p className='text-secondarytwo font-f18'>Discover a range of ready-to-use prompt templates designed to match every scenario, tone, and task. Click a category to get started!</p>
            </div>
            <Button onClick={scrollToTop} classes="mt-5 sm:mt-0 w-full sm:w-[322px] h-[96px] bg-primary text-slate rounded-[16px] font-bold flex justify-center items-center text-f30">Start Searching</Button>
          </div>
        </div>
        <div className="px-3 sm:px-0max-w-[1280px] m-auto mb-4">
          {categoriesData.map(category => (<div className='pt-2 pb-1 flex flex-col sm:flex-row gap-2'>
            <div onClick={() => setHandleSearch(category.headerText1)} className="w-full sm:w-[50%] border border-[#E1E1E1] p-4 rounded-[12px] cursor-pointer">
              <div className="border-b border-[#E1E1E1] flex justify-start items-center gap-2 mb-4 pb-4">
                <div className="w-[40px]">
                  <InSearch40 />
                </div>
                <p className="text-[#012234] font-semibold text-f20 text-left sm:text-center">{category.headerText1}</p>
              </div>
              <p className="text-[#3C4848] text-left">
                {category.text1}
              </p>
            </div>
            <div onClick={() => setHandleSearch(category.headerText2)} className="w-full sm:w-[50%] border border-[#E1E1E1] p-4 rounded-[12px] cursor-pointer">
              <div className="border-b border-[#E1E1E1] flex justify-start items-center gap-2 mb-4 pb-4">
                <div className="w-[40px]">
                  <InSearch40 />
                </div>
                <p className="text-[#012234] font-semibold text-f20 text-left sm:text-center">{category.headerText2}</p>
              </div>
              <p className="text-[#3C4848] text-left">
                {category.text2}
              </p>
            </div>
          </div>))}
        </div>
        <Footer />
      </>
      }
    </div>
  );
};

export default Banner;
